module.exports = __webpack_public_path__ + "img/xifanlianboluoyanwobing.fca9c6c1.jpg";